<div class="points-summary-bar d-flex justify-content-between d-lg-none">
  <!-- Back Button -->
  <div class="back-btn text-white cursor-pointer d-flex align-items-center d-lg-none" (click)="goBack()">
    <span class="material-symbols-outlined"> arrow_back_ios_new </span>
  </div>
  <!-- Points Bar -->
  <div class="justify-content-center point-container bg-glass-dark">
    <fgb-points-summary></fgb-points-summary>
  </div>
</div>
